export default __webpack_public_path__ + "static/media/fund-projection-screen.a7ca3fe9.svg";